import { render, staticRenderFns } from "./DownloadTab.vue?vue&type=template&id=9cad6f16&scoped=true&"
import script from "./DownloadTab.vue?vue&type=script&lang=js&"
export * from "./DownloadTab.vue?vue&type=script&lang=js&"
import style0 from "./DownloadTab.vue?vue&type=style&index=0&id=9cad6f16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cad6f16",
  null
  
)

export default component.exports